import request from "@/utils/request";
const apiPath = "/meet/meetingSignUpCarryPeople";
import { downloadBlob } from "@/utils/download";
const meetingSignUpCarryPeopleApi = {
  /**
   * 新增【会议报名携带人员】
   */
  create(data) {
    return request.post(apiPath, data);
  },
  /**
   * 修改【会议报名携带人员】
   */
  update(data) {
    return request.put(apiPath, data);
  },
  /**
   * 分页查询【会议报名携带人员】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query });
  },
  /**
   * 查询【会议报名携带人员】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query });
  },
  /**
   * 查看【会议报名携带人员】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`);
  },
  /**
   * 修改【会议报名携带人员】住宿信息
   */
  updatePutStay(data) {
    return request.put(apiPath + "/teev2/putStay", data);
  },
  /**
   * 下载Excel模板 · 住宿的
   */
  downloadExcelTemplateForStay(query) {
    return request
      .get(`${apiPath}/teev2/downloadExcelTemplateForStay`, {
        responseType: "blob",
        params: query
      })
      .then(res => downloadBlob(res, "住宿模版.xlsx"));
  },
  /**
   * 导入Excel · 住宿的
   */
  importForStay(data) {
    return request.post(`${apiPath}/teev2/importForStay`, data);
  },
  /**
   * 获取携带人员列表（teev2接口）
   */
  fetchListTeev2(query) {
    return request.get(`${apiPath}/teev2`, { params: query });
  }
};
export default meetingSignUpCarryPeopleApi;
